module.exports = __webpack_public_path__ + "static/dotted-half-circle-121954ed830a0eefd9d774c0178a397c.svg";